import { authRequest } from './api/auth';

class UrbanRenewalDataService {
  getProjects() {
    return authRequest.get('/urbanrenewal/admin/projects/');
  }

  createProject(data) {
    return authRequest.post('/urbanrenewal/admin/projects/', data);
  }

  updateProject(id, data) {
    return authRequest.patch(`/urbanrenewal/admin/projects/${id}/`, data);
  }

  deleteProject(id) {
    return authRequest.delete(`/urbanrenewal/admin/projects/${id}/`);
  }

  getLandowners(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/landowners/`);
  }

  updateLandowner(projectId, id, data) {
    return authRequest.patch(`/urbanrenewal/admin/projects/${projectId}/landowners/${id}/`, data);
  }

  deleteLandowners(projectId, ids) {
    return authRequest.delete(`/urbanrenewal/admin/projects/${projectId}/landowners/`, { data: { ids } });
  }

  regeneratePassword(projectId, id) {
    return authRequest.post(`/urbanrenewal/admin/projects/${projectId}/landowners/${id}/regenerate_password/`);
  }

  importLandowners(projectId, formData) {
    return authRequest.post(`/urbanrenewal/admin/projects/${projectId}/landowners/import/`, formData);
  }

  exportLandowners(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/landowners/export/`, { responseType: 'blob' });
  }

  getHousingUnits(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/housing-units/`);
  }

  updateHousingUnit(projectId, id, data) {
    return authRequest.patch(`/urbanrenewal/admin/projects/${projectId}/housing-units/${id}/`, data);
  }

  deleteHousingUnits(projectId, ids) {
    return authRequest.delete(`/urbanrenewal/admin/projects/${projectId}/housing-units/`, { data: { ids } });
  }

  importHousingUnits(projectId, formData) {
    return authRequest.post(`/urbanrenewal/admin/projects/${projectId}/housing-units/import/`, formData);
  }

  exportHousingUnits(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/housing-units/export/`, { responseType: 'blob' });
  }

  getParkingUnits(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/parking-units/`);
  }

  updateParkingUnit(projectId, id, data) {
    return authRequest.patch(`/urbanrenewal/admin/projects/${projectId}/parking-units/${id}/`, data);
  }

  deleteParkingUnits(projectId, ids) {
    return authRequest.delete(`/urbanrenewal/admin/projects/${projectId}/parking-units/`, { data: { ids } });
  }

  importParkingUnits(projectId, formData) {
    return authRequest.post(`/urbanrenewal/admin/projects/${projectId}/parking-units/import/`, formData);
  }

  exportParkingUnits(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/parking-units/export/`, { responseType: 'blob' });
  }

  getLandownerStatistics(projectId, params) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/statistics/landowner/`, { params });
  }

  exportLandownerStatistics(projectId, params) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/statistics/landowner/export/`, { params, responseType: 'blob' });
  }

  getHousingHeatmap(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/heatmap/housing/`);
  }

  getParkingHeatmap(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/heatmap/parking/`);
  }

  exportHousingHeatmap(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/heatmap/housing/export/`, { responseType: 'blob' });
  }

  exportParkingHeatmap(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/heatmap/parking/export/`, { responseType: 'blob' });
  }

  getHousingStatistics(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/statistics/housing/`);
  }

  exportHousingStatistics(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/statistics/housing/export/`, { responseType: 'blob' });
  }

  getParkingStatistics(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/statistics/parking/`);
  }

  exportParkingStatistics(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/statistics/parking/export/`, { responseType: 'blob' });
  }

  getSimulationData(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/simulation/data/`);
  }

  getManualInput(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/manual-input/`);
  }

  saveManualInput(projectId, payload) {
    return authRequest.post(`/urbanrenewal/admin/projects/${projectId}/manual-input/`, payload);
  }

  importManualInput(projectId, formData) {
    return authRequest.post(`/urbanrenewal/admin/projects/${projectId}/manual-input/import/`, formData);
  }

  exportManualInput(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/manual-input/export/`, { responseType: 'blob' });
  }

  getChangelog(projectId) {
    return authRequest.get(`/urbanrenewal/admin/projects/${projectId}/changelog/`);
  }

  // BE-29: Admin account management
  getAdmins() {
    return authRequest.get('/urbanrenewal/admin/admins/');
  }

  createAdmin(data) {
    return authRequest.post('/urbanrenewal/admin/admins/', data);
  }

  updateAdmin(id, data) {
    return authRequest.patch(`/urbanrenewal/admin/admins/${id}/`, data);
  }

  deactivateAdmin(id) {
    return authRequest.delete(`/urbanrenewal/admin/admins/${id}/`);
  }

  activateAdmin(id) {
    return authRequest.post(`/urbanrenewal/admin/admins/${id}/activate/`);
  }

  // BE-30: 品牌 Logo
  uploadLogo(formData) {
    return authRequest.post('/urbanrenewal/admin/logo/', formData);
  }

  deleteLogo() {
    return authRequest.delete('/urbanrenewal/admin/logo/');
  }

  getLogo() {
    return authRequest.get('/preference/?code=URBANRENEWAL_ADMIN_LOGO');
  }

  // AI 客服（UpChat webchat）設定：admin 讀/寫（tenant 級，{ enabled, url, token }）
  getAiSupport() {
    return authRequest.get('/urbanrenewal/admin/ai-support/');
  }

  saveAiSupport(data) {
    return authRequest.put('/urbanrenewal/admin/ai-support/', data);
  }
}

export default new UrbanRenewalDataService();
